import React from "react";
import { Message } from "lib/components/index";

import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { ProductPickupPointDecorator } from "lib/decorators/index";

export default class ProductPickupPointFormSection extends React.PureComponent {
  handlePropChange(prop, value) {
    const { product_pickup_point, onChange } = this.props;
    const nextProductPickupPoint = new ProductPickupPointDecorator({
      ...product_pickup_point,
      [prop]: value,
    });
    onChange(nextProductPickupPoint);
  }

  handleTranslationPropChange(prop, value) {
    const { product_pickup_point, editedLocale, onChange } = this.props;
    const nextProductPickupPoint = new ProductPickupPointDecorator({
      ...product_pickup_point,
      translations: product_pickup_point.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([
          {
            ...product_pickup_point.getTranslation(editedLocale),
            [prop]: value,
          },
        ]),
    });
    onChange(nextProductPickupPoint);
  }

  handleLocationChange({ name, lat, lng }) {
    const { product_pickup_point, editedLocale, onChange } = this.props;
    const nextProductPickupPoint = new ProductPickupPointDecorator({
      ...product_pickup_point,
      location_lat: lat,
      location_lng: lng,
      translations: product_pickup_point.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([
          {
            ...product_pickup_point.getTranslation(editedLocale),
            location_name: name,
          },
        ]),
    });
    onChange(nextProductPickupPoint);
  }

  render() {
    const {
      readOnlyAccess,
      product_variant,
      product_pickup_point,
      product_price_currency,
      editedLocale,
      errors,
      name,
      onBlur,
      onRemove,
      onClose,
    } = this.props;

    return (
      <div className="ui box">
        <h4>
          {product_pickup_point._new
            ? I18n.t("papp.products.EditProductView.StepLocation.new_pickup_point_title")
            : I18n.t("papp.products.EditProductView.StepLocation.edit_pickup_point_title")}
        </h4>
        {!!errors[name] && <FormMessage error={errors[name]} />}
        <FormControl.LocationFormGroup
          {...FormControl.addProps(`${name}.location`, { errors })}
          value={{
            name: product_pickup_point.getTranslation(editedLocale).location_name,
            lat: product_pickup_point.location_lat,
            lng: product_pickup_point.location_lng,
          }}
          onBlur={onBlur}
          onChange={this.handleLocationChange.bind(this)}
          label={I18n.humanAttributeName("product_pickup_point", "location")}
          autoFocus={product_pickup_point._focus}
          readOnly={readOnlyAccess}
        />

        <div className="fields inline">
          <div className="fields inline widths equal">
            <FormControl.TimeFormGroup
              {...FormControl.addProps(`${name}.departure_time`, { errors })}
              value={product_pickup_point.departure_time}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "departure_time")}
              label={I18n.humanAttributeName("product_pickup_point", "departure_time")}
              inlineLabel
              readOnly={readOnlyAccess}
            />

            <FormControl.TimeFormGroup
              {...FormControl.addProps(`${name}.arrival_time`, { errors })}
              value={product_pickup_point.arrival_time}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "arrival_time")}
              label={I18n.humanAttributeName("product_pickup_point", "arrival_time")}
              inlineLabel
              readOnly={readOnlyAccess}
            />
          </div>
        </div>
        <FormControl.FormGroup
          {...FormControl.addProps(`${name}.additional_fee`, { errors })}
          label={I18n.humanAttributeName("product_pickup_point", "additional_fee")}
          inline
        >
          <FormControl.Money
            value={product_pickup_point.additional_fee}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "additional_fee")}
            defaultCurrency={product_price_currency}
            readOnly={readOnlyAccess}
          />
          <span className="u-marginLeft">
            {I18n.humanAttributeName("product_pickup_point", product_variant.pickup_points_price_type)}
          </span>
        </FormControl.FormGroup>
        <FormControl.TextAreaFormGroup
          {...FormControl.addProps(`${name}.additional_instructions`, {
            errors,
          })}
          value={product_pickup_point.getTranslation(editedLocale).additional_instructions}
          onBlur={onBlur}
          onChange={this.handleTranslationPropChange.bind(this, "additional_instructions")}
          label={I18n.humanAttributeName("product_pickup_point", "additional_instructions")}
          autoHeight
          placeholder={I18n.humanAttributeName("product_pickup_point", "additional_instructions_placeholder")}
          readOnly={readOnlyAccess}
        />
        {!readOnlyAccess && !product_pickup_point._new && (
          <a onClick={onRemove} className="ui button red basic">
            <i className="icon material-icons">close</i>{" "}
            {I18n.t("papp.products.EditProductView.StepLocation.remove_pickup_point")}
          </a>
        )}
        {!product_pickup_point._new && (
          <a onClick={onClose} className="ui button basic right floated">
            {I18n.t("papp.common.close")}
          </a>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepLocation/ProductPickupPointFormSection.jsx